var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Form, Button, Card, Flex, Skeleton, theme, Typography, } from '@robinpowered/ui-kit';
import { useConfig } from '../../context/ConfigContext';
import { useEventApi } from '../../hooks/useEvent/useEventApi';
import { useCreateEventSuggestedSpaceQuery } from '../../hooks/useCreateEventSuggestedSpaceQuery';
import { useEditEventSuggestedSpaceQuery } from '../../hooks/useEditEventSuggestedSpaceQuery';
import { transformSpaceAPIToSpaceType } from '../../SpaceBooking/utils';
import { useEventComposerGlobalContext } from '../../composers/EventComposerGlobalContext';
import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';
import { SparkleIcon } from './icons/SparkleIcon';
import { SpaceInfoWrapper } from './EventSpaceWrapper';
import { SpaceAmenities } from './SpaceAmenities';
import { LocationLevel } from './components/LocationLevel';
import { useCreateEventContext } from '../../composers/CreateEventContext';
import { useEditEventContext } from '../../composers/EditEventContext';
var GRADIENT_PRIMARY = "linear-gradient(130deg, \nvar(--Colors-Brand-Primary-colorPrimary, #be1f77) 22.89%, \nvar(--Colors-Brand-Info-colorInfo, #2774c1) 77.11%)";
var borderGradientShift = keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  0% {\n    background-position: 0 0, 0% 50%;\n  }\n  100% {\n    background-position: 0 0, 100% 50%;\n  }\n"], ["\n  0% {\n    background-position: 0 0, 0% 50%;\n  }\n  100% {\n    background-position: 0 0, 100% 50%;\n  }\n"])));
var SuggestedCard = styled(Card)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  .ant-card-actions {\n    gap: 4px !important;\n    li {\n      margin: 0px;\n      border: 0px !important;\n    }\n  }\n  .ant-card-body {\n    padding: 0px;\n  }\n  margin-bottom: 8px;\n  border: 1px solid transparent;\n  border-radius: 10px;\n  background: linear-gradient(\n        var(--Colors-Base-White, #fff),\n        var(--Colors-Base-White, #fff)\n      )\n      padding-box,\n    linear-gradient(\n        120deg,\n        rgba(207, 52, 153, 0.55),\n        rgba(47, 128, 211, 0.55),\n        rgba(207, 52, 153, 0.55)\n      )\n      border-box;\n  background-size: 100% 100%, 200% 200%;\n  background-position: 0 0, 0% 50%;\n  animation: ", " 0.7s ease-in-out infinite alternate;\n\n  @media (prefers-reduced-motion: reduce) {\n    animation: none;\n    background-size: 100% 100%, 100% 100%;\n    background-position: 0 0, 0 0;\n  }\n"], ["\n  .ant-card-actions {\n    gap: 4px !important;\n    li {\n      margin: 0px;\n      border: 0px !important;\n    }\n  }\n  .ant-card-body {\n    padding: 0px;\n  }\n  margin-bottom: 8px;\n  border: 1px solid transparent;\n  border-radius: 10px;\n  background: linear-gradient(\n        var(--Colors-Base-White, #fff),\n        var(--Colors-Base-White, #fff)\n      )\n      padding-box,\n    linear-gradient(\n        120deg,\n        rgba(207, 52, 153, 0.55),\n        rgba(47, 128, 211, 0.55),\n        rgba(207, 52, 153, 0.55)\n      )\n      border-box;\n  background-size: 100% 100%, 200% 200%;\n  background-position: 0 0, 0% 50%;\n  animation: ", " 0.7s ease-in-out infinite alternate;\n\n  @media (prefers-reduced-motion: reduce) {\n    animation: none;\n    background-size: 100% 100%, 100% 100%;\n    background-position: 0 0, 0 0;\n  }\n"])), borderGradientShift);
var SuggestedSpaceInfo = styled(Flex)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  border-radius: 4px;\n  padding: 8px;\n  align-self: stretch;\n  background: var(\n    --gradientBg,\n    linear-gradient(\n      97deg,\n      var(--Colors-Brand-Primary-colorPrimaryBg, #fff0f6) 0%,\n      var(--Colors-Base-Purple-1, #f9f0ff) 25%,\n      var(--Colors-Brand-Control-controlItemBgActive, #f0faff) 100%\n    )\n  );\n"], ["\n  border-radius: 4px;\n  padding: 8px;\n  align-self: stretch;\n  background: var(\n    --gradientBg,\n    linear-gradient(\n      97deg,\n      var(--Colors-Brand-Primary-colorPrimaryBg, #fff0f6) 0%,\n      var(--Colors-Base-Purple-1, #f9f0ff) 25%,\n      var(--Colors-Brand-Control-controlItemBgActive, #f0faff) 100%\n    )\n  );\n"])));
var SuggestionText = styled(Typography.Text)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  background: var(--gradientPrimary, ", ");\n  background-clip: text;\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n"], ["\n  background: var(--gradientPrimary, ", ");\n  background-clip: text;\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n"])), GRADIENT_PRIMARY);
var SpaceImage = styled.img(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  border-radius: 4px;\n  width: 40px;\n  height: 40px;\n  object-fit: cover;\n"], ["\n  border-radius: 4px;\n  width: 40px;\n  height: 40px;\n  object-fit: cover;\n"])));
var SuggestionButton = styled(Button)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  width: 100%;\n  align-self: flex-start;\n  border-radius: 4px;\n"], ["\n  width: 100%;\n  align-self: flex-start;\n  border-radius: 4px;\n"])));
/**
 * Shared presentational layer: apply logic + UI for a suggested space.
 * Rendered by SuggestedSpaceCreatePrompt and SuggestedSpaceEditPrompt.
 */
var SuggestedSpaceContent = function (_a) {
    var suggestedSpaceId = _a.suggestedSpaceId, loading = _a.loading;
    var t = useTranslation('meetingRooms').t;
    var token = theme.useToken().token;
    var setValue = useFormContext().setValue;
    var _b = __read(useWatch({
        name: ['spaces'],
    }), 1), spaces = _b[0];
    var _c = useConfig(), accessToken = _c.accessToken, environmentUrls = _c.environmentUrls, tenantId = _c.tenantId, userContext = _c.userContext;
    var currentOrg = userContext.currentOrg;
    var _d = useEventComposerGlobalContext(), onError = _d.onError, setShowSuggestedSpace = _d.setShowSuggestedSpace, showSuggestedSpace = _d.showSuggestedSpace, setSpaceBookingOpen = _d.setSpaceBookingOpen;
    var fetchSpace = useEventApi({
        onError: onError,
        accessToken: accessToken,
        apiUrl: environmentUrls.apiUrl,
        baseApiUrl: environmentUrls.baseApiUrl,
        tenantId: tenantId,
        currentOrg: currentOrg,
    }).fetchSpace;
    var _e = __read(useState(false), 2), fetchingSuggestedSpace = _e[0], setFetchingSuggestedSpace = _e[1];
    var _f = __read(useState(null), 2), suggestedSpace = _f[0], setSuggestedSpace = _f[1];
    useEffect(function () {
        if (!suggestedSpaceId)
            return;
        setShowSuggestedSpace(true);
        setSuggestedSpace(null);
        setFetchingSuggestedSpace(true);
        var cancelled = false;
        fetchSpace({ spaceId: suggestedSpaceId })
            .then(function (space) {
            if (cancelled)
                return;
            if (!space) {
                setShowSuggestedSpace(false);
                return;
            }
            setSuggestedSpace(transformSpaceAPIToSpaceType(space));
        })
            .catch(function () {
            setShowSuggestedSpace(false);
        })
            .finally(function () {
            if (!cancelled) {
                setFetchingSuggestedSpace(false);
            }
        });
        return function () {
            cancelled = true;
        };
    }, [suggestedSpaceId, fetchSpace, setShowSuggestedSpace]);
    var handleUseSuggested = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var currentSpaces, newSpaces;
        return __generator(this, function (_a) {
            if (!suggestedSpace)
                return [2 /*return*/];
            currentSpaces = spaces !== null && spaces !== void 0 ? spaces : [];
            if (currentSpaces.some(function (s) { return s.id.toString() === suggestedSpaceId; }))
                return [2 /*return*/];
            newSpaces = __spreadArray(__spreadArray([], __read(currentSpaces), false), [suggestedSpace], false);
            setShowSuggestedSpace(false);
            setValue('spaces', newSpaces, {
                shouldDirty: true,
            });
            return [2 /*return*/];
        });
    }); }, [
        suggestedSpaceId,
        setValue,
        suggestedSpace,
        spaces,
        setShowSuggestedSpace,
    ]);
    var bookButtonGradient = "linear-gradient(120deg, ".concat(token.colorPrimary, " 8%, ").concat(token.colorInfo, " 92%)");
    if (!showSuggestedSpace) {
        return null;
    }
    var suggestedSpaceActions = function () {
        return [
            _jsx(SuggestionButton, { type: "primary", onClick: handleUseSuggested, style: {
                    backgroundImage: bookButtonGradient,
                    borderColor: 'transparent',
                    color: token.colorTextLightSolid,
                }, children: t('suggested_space.add_to_event') }, "add-to-event"),
            _jsx(SuggestionButton, { type: "default", onClick: function () {
                    setSpaceBookingOpen(true);
                }, children: t('suggested_space.find_another') }, "find-another-space"),
        ];
    };
    return (_jsx(Form.Item, { label: _jsxs(Flex, { vertical: false, gap: 4, align: "center", children: [_jsx(SparkleIcon, {}), _jsx(SuggestionText, { children: t('suggested_space.suggested_space') })] }), children: _jsx(SuggestedCard, { style: {
                borderRadius: '4px',
                padding: '0px',
            }, styles: {
                actions: {
                    padding: token.paddingSM,
                },
            }, actions: suggestedSpaceActions(), children: fetchingSuggestedSpace || loading || !suggestedSpace ? (_jsx(SpaceInfoWrapper, { showBorder: false, children: _jsx(Skeleton, { active: true, paragraph: { rows: 3 } }) })) : (_jsxs(_Fragment, { children: [_jsxs(SpaceInfoWrapper, { showBorder: false, style: {
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            display: 'flex',
                        }, children: [_jsxs(Flex, { gap: 4, justify: "flex-start", style: {
                                    flexDirection: 'column',
                                    alignSelf: 'flex-start',
                                }, children: [_jsx(Typography.Title, { level: 5, style: { marginBottom: 0 }, children: suggestedSpace === null || suggestedSpace === void 0 ? void 0 : suggestedSpace.name }), (suggestedSpace === null || suggestedSpace === void 0 ? void 0 : suggestedSpace.locationId) && (suggestedSpace === null || suggestedSpace === void 0 ? void 0 : suggestedSpace.levelId) && (_jsx(LocationLevel, { locationId: suggestedSpace === null || suggestedSpace === void 0 ? void 0 : suggestedSpace.locationId.toString(), levelId: suggestedSpace === null || suggestedSpace === void 0 ? void 0 : suggestedSpace.levelId.toString() })), (suggestedSpace === null || suggestedSpace === void 0 ? void 0 : suggestedSpace.amenities) && (_jsx(SpaceAmenities, { capacity: (suggestedSpace === null || suggestedSpace === void 0 ? void 0 : suggestedSpace.capacity) || undefined, amenities: (suggestedSpace === null || suggestedSpace === void 0 ? void 0 : suggestedSpace.amenities) || [] }))] }), (suggestedSpace === null || suggestedSpace === void 0 ? void 0 : suggestedSpace.image) && (_jsx(SpaceImage, { alt: t('create_event.space_image_alt', {
                                    spaceName: suggestedSpace.name,
                                }), title: t('create_event.space_image_alt', {
                                    spaceName: suggestedSpace.name,
                                }), src: suggestedSpace.image }))] }), (suggestedSpace === null || suggestedSpace === void 0 ? void 0 : suggestedSpace.capacity) && (_jsx(SpaceInfoWrapper, { showBorder: false, style: { paddingTop: 0 }, children: _jsxs(SuggestedSpaceInfo, { gap: 4, align: "center", vertical: false, children: [_jsx(SuggestionText, { size: "small", style: { color: token.colorTextSecondary }, children: t('suggested_space.good_match') }), _jsx(Typography.Text, { size: "small", style: { color: token.colorTextSecondary }, children: t('suggested_space.fits', {
                                        count: suggestedSpace === null || suggestedSpace === void 0 ? void 0 : suggestedSpace.capacity,
                                    }) }), _jsx(Typography.Text, { size: "small", style: { color: token.colorTextSecondary }, children: t('suggested_space.separator') }), _jsx(Typography.Text, { size: "small", style: { color: token.colorTextSecondary }, children: t('suggested_space.meeting_room') })] }) }))] })) }) }));
};
export var SuggestedSpaceCreatePrompt = function (_a) {
    var _b;
    var levelId = _a.levelId;
    var _c = __read(useWatch({
        name: ['invitees'],
    }), 1), invitees = _c[0];
    var totalInviteesWithUserId = invitees.filter(function (invitee) { return invitee.user_id; }).length;
    var _d = useCreateEventSuggestedSpaceQuery({
        levelId: levelId,
        totalInviteesWithUserId: totalInviteesWithUserId,
    }), suggestedSpaceId = _d.suggestedSpaceId, loading = _d.loading;
    var initialEvent = useCreateEventContext().initialEvent;
    if (!suggestedSpaceId ||
        ((_b = initialEvent === null || initialEvent === void 0 ? void 0 : initialEvent.spaceIds) === null || _b === void 0 ? void 0 : _b.includes(suggestedSpaceId.toString()))) {
        return null;
    }
    return (_jsx(SuggestedSpaceContent, { suggestedSpaceId: suggestedSpaceId, loading: loading }));
};
export var SuggestedSpaceEditPrompt = function (_a) {
    var _b;
    var levelId = _a.levelId;
    var _c = __read(useWatch({
        name: ['invitees'],
    }), 1), invitees = _c[0];
    var totalInviteesWithUserId = invitees.filter(function (invitee) { return invitee.user_id; }).length;
    var _d = useEditEventSuggestedSpaceQuery({
        levelId: levelId,
        totalInviteesWithUserId: totalInviteesWithUserId,
    }), suggestedSpaceId = _d.suggestedSpaceId, loading = _d.loading;
    var initialEvent = useEditEventContext().initialEvent;
    if (!suggestedSpaceId ||
        ((_b = initialEvent === null || initialEvent === void 0 ? void 0 : initialEvent.spaceIds) === null || _b === void 0 ? void 0 : _b.includes(suggestedSpaceId.toString()))) {
        return null;
    }
    return (_jsx(SuggestedSpaceContent, { suggestedSpaceId: suggestedSpaceId, loading: loading }));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
